import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import Tag from '../../Atoms/Tag';
import Button from '../../Atoms/Button';
import UserInfo from '../../Molecules/UserInfo';
import Pagination from '../../Molecules/Pagination';
import { Props as CardBlogProps } from '../../Molecules/CardBlog';
import CardBlogList from '../../Organisms/CardBlogList';
import Promo from '../../Organisms/Promo';

import cardImg1 from '../../../assets/img/card-image01.png';
import cardImg2 from '../../../assets/img/card-image02.png';
import placeholder from '../../../assets/img/placeholder.png';
import cardImg3 from '../../../assets/img/card-image03.png';
import cardImg4 from '../../../assets/img/card-image04.png';
import promoImg from '../../../assets/img/intro-img01.png';

const posts = [
  {
    title: 'Hoe maak je een goede vacaturetekst?',
    tags: [
      {
        text: '2 minutes',
        icon: 'clock'
      },
      {
        text: 'award22'
      }
    ],
    img: {
      src: placeholder,
      alt: 'Card image 1'
    }
  },
  {
    title: 'Hoe maak je een goede vacaturetekst?',
    tags: [
      {
        text: '2 minutes',
        icon: 'clock'
      }
    ],
    img: {
      src: cardImg2,
      alt: 'Card image 3'
    }
  },
  {
    title: 'Hoe maak je een goede vacaturetekst',
    tags: [
      {
        text: '2 minutes',
        icon: 'clock'
      }
    ],
    img: {
      src: cardImg3,
      alt: 'Card image 4'
    }
  },
  {
    title: 'Hoe maak je een goede vacaturetekst?',
    tags: [
      {
        text: '2 minutes',
        icon: 'award'
      }
    ],
    img: {
      src: cardImg4,
      alt: 'Card image 3'
    }
  },
  {
    title: 'Hoe maak je een goede vacaturetekst?',
    tags: [
      {
        text: '2 minutes',
        icon: 'award'
      }
    ],
    img: {
      src: cardImg4,
      alt: 'Card image 3'
    }
  },
  {
    title: 'Hoe maak je een goede vacaturetekst?',
    tags: [
      {
        text: '2 minutes',
        icon: 'award'
      }
    ],
    img: {
      src: cardImg4,
      alt: 'Card image 3'
    }
  },
  {
    title: 'Hoe maak je een goede vacaturetekst?',
    tags: [
      {
        text: '2 minutes',
        icon: 'award'
      }
    ],
    img: {
      src: cardImg4,
      alt: 'Card image 3'
    }
  },
  {
    title: 'Hoe maak je een goede vacaturetekst?',
    tags: [
      {
        text: '2 minutes',
        icon: 'award'
      }
    ],
    img: {
      src: cardImg4,
      alt: 'Card image 3'
    }
  },
  {
    title: 'Hoe maak je een goede vacaturetekst?',
    tags: [
      {
        text: '2 minutes',
        icon: 'award'
      }
    ],
    img: {
      src: cardImg4,
      alt: 'Card image 3'
    }
  },
  {
    title: 'Hoe maak je een goede vacaturetekst?',
    tags: [
      {
        text: '2 minutes',
        icon: 'award'
      }
    ],
    img: {
      src: cardImg4,
      alt: 'Card image 3'
    }
  }
];

function Blog() {
  return (
    <>
      <Promo
        bgOverlayMode
        bgImg={promoImg}
        bg="linear-gradient(180deg, rgba(110, 119, 248, 0.75) 0%, #606AF8 100%)"
      >
        <div>
          <div className="max-w-md md:max-w-lg">
            <Title
              as="h1"
              size={2}
              color="white"
              className="mb-3 md:mb-7 lg:mb-8"
            >
              Four overcome and back typically each she to
              your from
            </Title>
            <Text
              color="white"
              font="camphor"
              weight={400}
              className="mb-3 md:mb-7"
            >
              To gleaning is kind and, desk, exerted sinking
              in years; Process arm by occupied borne a
              small disguised negatives, to for out of
              continues as volume ideas into of well the
              better my often that his getting I attempt.
              First rippedup, another, and minutes. She
              another is to in which.
            </Text>
            <div className="post-intro-tags mb-5 flex w-full flex-wrap gap-x-14 gap-y-5">
              <UserInfo
                img={{
                  src: cardImg1,
                  alt: 'Claudine Photo'
                }}
                textColor="white"
                text="Peter-Jan Kloppers"
              />

              <div className="flex items-center gap-2 text-white">
                <Tag
                  text="1 minutes"
                  icon="clock"
                  className="gap-x-2.5 text-sm leading-normal md:text-base md:leading-normal lg:text-lg lg:leading-normal"
                />
              </div>
            </div>
            <Button
              text="Lees meer"
              as="a"
              href="/"
              color="accent"
              iconName="arrow-right"
            />
          </div>
        </div>
      </Promo>
      <div className="mx-auto w-full max-w-7xl px-7 pt-20">
        <Title
          as="h2"
          size={2}
          className="mb-3 md:mb-7 lg:mb-8"
        >
          Blog
        </Title>
      </div>
      <CardBlogList posts={posts as CardBlogProps[]} />
      <Pagination
        defaultCurrent={1}
        className=""
        pageSize={10}
        total={60}
      />
    </>
  );
}

export default Blog;
